"use client"

import styled from "styled-components"
import {
  Badge,
  Card,
  CardHeader,
  Sparkline,
  Subtitle,
  Title,
  TitleGroup,
} from "./primitives"

const indices = [
  { name: "S&P 500", value: "5,918", change: "+0.74%", up: true, trend: [58, 59, 58, 60, 61, 62] },
  { name: "Nasdaq 100", value: "21,410", change: "+1.12%", up: true, trend: [200, 205, 203, 210, 214, 218] },
  { name: "Dow Jones", value: "43,280", change: "-0.18%", up: false, trend: [436, 434, 435, 433, 432, 432] },
  { name: "Russell 2000", value: "2,284", change: "+0.42%", up: true, trend: [224, 226, 225, 227, 228, 229] },
  { name: "FTSE 100", value: "8,214", change: "+0.31%", up: true, trend: [81, 81, 82, 81, 82, 82] },
  { name: "Nikkei 225", value: "39,150", change: "-0.55%", up: false, trend: [396, 394, 393, 392, 391, 391] },
]

const Grid = styled.div`
  margin-top: 1.25rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem;
`

const Cell = styled.div`
  border-radius: 1rem;
  background: color-mix(in oklch, var(--color-muted) 50%, transparent);
  border: 1px solid color-mix(in oklch, var(--color-border) 50%, transparent);
  padding: 0.75rem 0.875rem;
`

const CellTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const Name = styled.span`
  font-size: 0.8125rem;
  font-weight: 500;
  color: var(--color-card-foreground);
`

const Value = styled.p`
  margin: 0.375rem 0 0;
  font-family: var(--font-mono);
  font-size: 1.0625rem;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: var(--color-card-foreground);
`

const Change = styled.span<{ $up: boolean }>`
  font-family: var(--font-mono);
  font-size: 0.75rem;
  font-weight: 600;
  color: ${(p) => (p.$up ? "var(--color-optimal-foreground)" : "var(--color-alert)")};
`

export function GlobalIndicesCard() {
  return (
    <Card>
      <CardHeader>
        <TitleGroup>
          <Title>Global indices</Title>
          <Subtitle>Daily regional benchmarks</Subtitle>
        </TitleGroup>
        <Badge tone="optimal">Markets open</Badge>
      </CardHeader>

      <Grid>
        {indices.map((idx) => (
          <Cell key={idx.name}>
            <CellTop>
              <Name>{idx.name}</Name>
              <Sparkline
                points={idx.trend}
                width={40}
                height={18}
                color={idx.up ? "var(--color-optimal)" : "var(--color-alert)"}
              />
            </CellTop>
            <Value>{idx.value}</Value>
            <Change $up={idx.up}>{idx.change}</Change>
          </Cell>
        ))}
      </Grid>
    </Card>
  )
}

export default GlobalIndicesCard
